import React from "react";
import cn from "classnames";
import styles from "./text-button.module.scss";

interface TextButtonProps {
  clickHandler: () => void;
  text: string;
  variant?: string | string[];
  disabled?: boolean;
}

const cssClassName = "text-button";

export const TextButton = ({
  clickHandler,
  text,
  variant,
  disabled = false,
}: TextButtonProps) => {
  let variantClass = "";

  if (typeof variant === "string") {
    variantClass = styles[`${cssClassName}--${variant}`];
  } else if (Array.isArray(variant)) {
    variantClass = variant
      .map((v) => styles[`${cssClassName}--${v}`])
      .join(" ");
  }
  return (
    <button
      onClick={clickHandler}
      disabled={disabled}
      className={cn(styles[cssClassName], variantClass)}
    >
      {text}
    </button>
  );
};
